import { AccountNumberParams, managePricingContext } from 'pages/managePricing/managePricingResolver';
import { ROUTES } from 'routing';
import { formatLocalDateToLocalISODateTimeString } from 'shared/utility';
import { DeviationConfirmationRequest } from 'types/backend';
import { AddModelCurrentPricesForm } from 'types/forms';
import UseDynamicUrl from './useDynamicUrl';
import useSubmitNew from './useSubmitNew';

export function useConfirmDeviationRequest() {
    const { path } = UseDynamicUrl<AccountNumberParams>({ route: ROUTES.managePricing });
    const mapper = (form: AddModelCurrentPricesForm): DeviationConfirmationRequest[] =>
        form.addedDeviations.map((item) => {
            const requestItem: DeviationConfirmationRequest = {
                modelCurrentPrice: {
                    ...item.modelCurrentPrice,
                    targetPrice: Number(item.modelCurrentPrice.targetPrice),
                    price: Number(item.modelCurrentPrice.price),
                    currentpriceid: Number(item.modelCurrentPrice.currentpriceid),
                    deleted: false,
                    effectivestart: new Date().toISOString(), // not used in backend
                    lastupdated: undefined,
                    effectiveend: undefined,
                    status: item.modelCurrentPrice.status,
                    enddate: formatLocalDateToLocalISODateTimeString(item.modelCurrentPrice.enddate),
                    startdate: formatLocalDateToLocalISODateTimeString(item.modelCurrentPrice.startdate),
                },
                deviationDetails: item.deviationDetails,
                deviationReasonNotes: item.deviationReasonNotes,
            };
            return requestItem;
        });
    const submitRequest = useSubmitNew({
        mapper,
        name: 'deviation',
        successRoute: path,
        context: managePricingContext,
    });

    return submitRequest;
}
